export interface StepperHeaderProps {
  title: string;
  description?: string;
  badge?: string;
}

export function StepperHeader({ title, description, badge }: StepperHeaderProps) {
  return (
    <>
      <div className="flex items-center justify-between gap-2">
        <h1 className="text-2xl font-bold">{title}</h1>
        {badge && <div className="bg-warning/20 text-warning rounded-full px-2 py-1 text-xs font-medium">{badge}</div>}
      </div>
      {description && <p className="text-default-500">{description}</p>}
    </>
  );
}
